/* eslint-disable */
export default {
  sureToDeleteVoiceMail: 'Soll diese Voicemail wirklich gelöscht werden?',
  sureToDeleteFax: 'Soll dieses Fax wirklich gelöscht werden?',
  doNotAskAgain: 'Nicht erneut fragen',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
